import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initSentry } from "./lib/sentry";

initSentry();

if (window.location.pathname === "/" || (!window.location.pathname.startsWith("/main/") && window.location.pathname !== "/main")) {
  window.location.replace("/main/");
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
